import { cx } from "@/utils/cx";
import { getTagBadgeColors, resolveTagColor } from "@/utils/tag-colors";
import { Dot } from "@/components/foundations/dot-icon";
import type { TalentTagDto } from "@fp/admin-api-client/types/talentTagDto.js";
import { X } from "@untitledui/icons";

export const FilterTag = ({
  tag,
  selected,
  onClick,
  onDelete,
}: {
  tag: TalentTagDto;
  selected: boolean;
  onClick?: (tag: TalentTagDto) => void;
  onDelete?: (tag: TalentTagDto) => void;
}) => {
  const { bg, text } = getTagBadgeColors(resolveTagColor(tag.hexColor));

  return (
    <button
      type="button"
      className={cx(
        "flex cursor-default items-center gap-0.75",
        "rounded-md",
        "ring-1 ring-inset focus:outline-hidden focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus-ring",
        "px-3 py-1.5 text-md font-medium",
        selected && "ring-2 ring-brand-500",
        !selected && "ring-black/10",
      )}
      style={{ backgroundColor: bg, color: text }}
      onClick={() => onClick?.(tag)}
      tabIndex={0}
    >
      <Dot size="sm" className="mr-1" style={{ color: resolveTagColor(tag.hexColor) }} />
      {tag.name}
      {onDelete && <X className="ml-2 h-4 w-4" onClick={() => onDelete(tag)} />}
    </button>
  );
};